module.exports = __webpack_public_path__ + "static/media/tmb_imgInfoM2.2cea973c.png";